import i18next from 'i18next'
import * as React from 'react'
import { useEffect } from 'react'
import { useAuthLoginPasskeys } from '../../../../../pages/Auth/Login/useAuthLoginPasskeys'
import { BasicButton } from '../../../../BasicButton/BasicButton'
import { InputMessages } from '../../../../Input/InputMessages'
import { Section } from '../../../../Sections'
import { EmailSectionProps } from '../EmailSection/interfaces'
import { useSuccessLoginNavigation } from '../../hooks/useSuccessLoginNavigation'
import css from './PasskeysSection.module.scss'

export const PasskeysSection = ({ navigate: navigateSection, context }: EmailSectionProps): React.ReactElement => {
	const { passkeyBusy, passkeyStatus, onPasskeySignIn } = useAuthLoginPasskeys()
	const navigateAfterQRCodeAuth = useSuccessLoginNavigation({ privacyChecked: context.privacyChecked })

	const handlePasskeySignIn = async (): Promise<void> => {
		try {
			await onPasskeySignIn()
			navigateAfterQRCodeAuth()
		} catch (err) {
			// do nothing
		}
	}
	useEffect(() => {
		void handlePasskeySignIn()
	}, [])

	return (
		<Section side="right" title={'Passkeys'} navLeft={(): void => navigateSection('SignInSection')}>
			<div className={css.container}>
				<BasicButton disabled={passkeyBusy} isLoading={passkeyBusy} size="sm" variant="grey" onClick={onPasskeySignIn}>
					{i18next.t('auth.passkeys.signIn', { defaultValue: 'Sign in with passkey' })}
				</BasicButton>
				{passkeyStatus ? <InputMessages messages={[{ message: passkeyStatus, type: 'error' }]} /> : null}
			</div>
		</Section>
	)
}
